import React, { useEffect, useState } from "react";
import { generateExcel, getHeaderColNames, excelColorCodes, transformNavDataForLabels, getUserID } from "./../utils";
import { proxy } from '../process/api';
import ReportOptions from "./ReportOptions";

import { useNavigate } from "react-router-dom";

const NewUser = () => {

    const [pageTitle, setPageTitle] = useState('');
    const [loginErrorMessage, setLoginErrorMsg] = useState('');
    const currentToken = localStorage.getItem('token');
    const [isValid, setIsValid] = useState(true);

    const [fName, setFName] = useState('');
    const [loginName, setLoginName] = useState('');
    const [isLoginError, setLoginError] = useState(false);
    const [isSuccess, setisSuccess] = useState(false);


    const navigate = useNavigate();






    const handleSubmit = async (event) => {

        if (fName == "") {
            alert("FName cannot be empty.");
            return;
        }
        if (loginName == "") {
            alert("Login name/username cannot be empty.");
            return;
        }


        event.preventDefault();

        var btnLogin = document.getElementById('btnReportGen');
        btnLogin.innerText = 'Processing...';

        const payload = {
            "loginName": loginName,
            "password": "123",
            "fname": fName,
            "userType": parseInt(document.getElementById('usertype-select').value),
            "roles": "",
            "lastLoginDateTime": "01-01-1900 00:00:00"
        }
        const apiResponse = await proxy(`/auth/addNewUser`, payload, "post");
 
        if (apiResponse.message == "User Added Successfully") {

            alert(`User with login ${loginName} has been added successfully!`)
            setFName('');
            setLoginName('');
            // var btnLogin = document.getElementById('btnReportGen');
            // btnLogin.innerText = 'ADD USER';
            navigate(`/settings-user-permissions/${apiResponse.id}/${loginName}/${parseInt(document.getElementById('usertype-select').value)}`)
            

        } else {

            alert(apiResponse.message);
            setFName('');
            setLoginName('');
            var btnLogin = document.getElementById('btnReportGen');
            btnLogin.innerText = 'ADD USER';
        }

    };



    useEffect(() => {

        transformNavDataForLabels("TL02").then(title => {
            setPageTitle(title);
        });

    }, []);

    return (
        <>
            <div class="main-content">

                <ReportOptions title="Add New User" >
                    <div className="report-option-wrapper">
                        <div className="report-option-row">
                            <div className="report-option-item">
                                <label style={{ minWidth: "140px" }}>First&nbsp;Name</label>
                                <input className="form-control" type="text" style={{ minWidth: "300px" }}

                                    value={fName}
                                    id="oldPass"
                                    onChange={(e) => { setFName(e.target.value); }}

                                />
                            </div>




                        </div>

                        <div className="report-option-row">
                            <div className="report-option-item">
                                <label style={{ minWidth: "140px" }}>Login&nbsp;Name</label>
                                <input className="form-control" type="text" style={{ minWidth: "300px" }}
                                    onChange={(e) => { setLoginName(e.target.value); }}
                                    id="oldPass"
                                    value={loginName}

                                />
                            </div>




                        </div>

                        <div className="report-option-row">
                            <div className="report-option-item">
                                <label style={{ minWidth: "140px" }}>User&nbsp;Type</label>

                                <select id="usertype-select" name="branch" className="form-control" >
                                    <option value="1" selected={true}>Branch</option>
                                    <option value="2">All India</option>
                                    <option value="3">Pmt</option>
                                    <option value="4">Hq</option>
                                    <option value="5">Multiple Branch</option>
                                </select>
                            </div>




                        </div>






                        <div className="report-option-action-row">
                            <button onClick={(e) => { navigate('/dashboard'); }} className="btn btn-outline btn-md btn-sec mr-10 fw-500">BACK</button>
                            <button onClick={handleSubmit} className="btn btn-md btn-primary pr-30 pl-30 fw-500 " id="btnReportGen" >ADD USER</button>
                        </div>






                    </div>

                </ReportOptions>
            </div>
        </>
    );
}

export default NewUser;